import { render, staticRenderFns } from "./downPackageOrder.vue?vue&type=template&id=3944674c&"
import script from "./downPackageOrder.vue?vue&type=script&lang=js&"
export * from "./downPackageOrder.vue?vue&type=script&lang=js&"
import style0 from "./downPackageOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports